export type FlowResult = {
    success: boolean;
    intentId?: string;
    paymentMethodId?: string;
    subscriptionId?: string;
    status?: string;
    error?: string;
};

export const extractErrorMessage = (e: unknown): string => {
    if (e instanceof Error) return e.message;
    if (typeof e === 'string') return e;
    if (e && typeof e === 'object') {
        const err = e as Record<string, unknown>;
        if (Array.isArray(err.errors) && err.errors.length > 0) {
            return err.errors.map((x: { message?: string }) => x.message || 'Unknown error').join('; ');
        }
        if (typeof err.message === 'string') return err.message;
        return JSON.stringify(e);
    }
    return 'Unknown error';
};

// FNP-412: stripe-api getStripeEventPipelineHealth.
export type StripePartnerRuleHealth = {
    ruleName: string;
    ruleArn: string;
    state?: string | null;
    startsStateMachine: boolean;
    matchedEvents: number;
    triggeredRules: number;
    invocations: number;
    failedInvocations: number;
    deadLetterInvocations?: number | null;
};

export type StripePartnerBusHealth = {
    eventBusName: string;
    eventBusArn: string;
    observability: 'OBSERVED' | 'NO_RULES';
    observabilityLabel: string;
    eventsReceived: number;
    rules: StripePartnerRuleHealth[];
};

export type StripeStateMachineHealth = {
    stateMachineArn: string;
    executionsStarted: number;
    executionsSucceeded: number;
    executionsFailed: number;
    executionsTimedOut: number;
    executionsAborted: number;
};

export type EventPipelineHealth = {
    windowStart: string;
    windowEnd: string;
    windowCapped: boolean;
    periodSeconds: number;
    buses: StripePartnerBusHealth[];
    stateMachine: StripeStateMachineHealth;
};
